import i18n from "i18next";

import type { Group } from "api/services/treatment/schemas/Treatment";

export function translateTemplateGroup(key: Group): string {
  const count = 1;

  const keyMap: Record<Group, string> = {
    back: i18n.t("patients.pain_location.back_icu", { count }),
    elbow: i18n.t("patients.pain_location.elbow_icu", { count }),
    fall_prevention: i18n.t("patients.pain_location.fall_prevention_icu", { count }),
    foot: i18n.t("patients.pain_location.foot_icu", { count }),
    hand: i18n.t("patients.pain_location.hand_icu", { count }),
    hip: i18n.t("patients.pain_location.hip_icu", { count }),
    knee: i18n.t("patients.pain_location.knee_icu", { count }),
    lower_leg: i18n.t("patients.pain_location.lower_leg_icu", { count }),
    neck: i18n.t("patients.pain_location.neck_icu", { count }),
    osteoporosis: i18n.t("patients.pain_location.osteoporosis_icu", { count }),
    shoulder: i18n.t("patients.pain_location.shoulder_icu", { count }),
  };

  return keyMap[key] || "";
}
